import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import { QuotesModalLineFragmentDoc } from './QuotesModalLine.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedBestBuyLineFragmentDoc = gql`
  fragment AdvancedBestBuyLine on RequisitionLine {
    id
    uuid
    unitPrice
    cataloguedProduct {
      id
    }
    product {
      id
      availableQuotes {
        unitPrice
        taxPercentage
        ...ActiveSupplierQuote
      }
    }
    ...QuotesModalLine
  }
  ${ActiveSupplierQuoteFragmentDoc}
  ${QuotesModalLineFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedBestBuyLineFragment, unknown>
